import React from "react"
import adapter from "@hg/adapt-sdk"
import { THGResult } from "@hg/hg-web-sdk/dist/core/account/HG"
import { RoleProvider, RoleProviderProps } from "@hg/one-account"
import { HG_SDK } from "@hg/one-account/lib/types"

import { useFetchRole } from "@/hooks/useFetchRole"
import { useLogin } from "@/hooks/useLogin"
import { useI18nStore, useTranslation } from "@/locales"
import Toast from "@/topic/rogue_4/components/Toast"
import EventBus from "@/utils/eventBus"

export interface CustomLoginModalProps {
    smsCountDown: number
    sendSMS: (phone: string) => Promise<THGResult<null>>
    loginByPassword: (
        username: string,
        password: string
    ) => ReturnType<HG_SDK["User"]["loginByPassword"]>
    loginByCode: (
        username: string,
        smsCode: string
    ) => ReturnType<HG_SDK["User"]["loginByCode"]>
}

const Layout: React.FC<{
    context: {
        type: string
        dispatch: React.Dispatch<any>
    }
    needReload?: boolean
    customChannelSelect?: boolean
    customLoginDialog?: boolean
    children: React.ReactNode
}> = ({
    children,
    context,
    needReload = false,
    customChannelSelect = true,
    customLoginDialog = true,
}) => {
    const { returnButton } = adapter.ui

    const { dispatch } = context

    // 登陆
    const handleSelectRole = useLogin()

    // 获取用户信息
    const handleFetchRoleInfo = useFetchRole(dispatch)

    const { sdkReady } = useI18nStore()

    const { t } = useTranslation()

    return (
        <RoleProvider
            gameCode="ak"
            sdkReady={sdkReady as RoleProviderProps["sdkReady"]}
            customChannelSelect={customChannelSelect && __LOCALE === "zh-cn"}
            accountProviderProps={{
                customLoginDialog: customLoginDialog && __LOCALE === "zh-cn",
            }}
            onSelectRole={async (token) => {
                const res = await handleSelectRole(token)
                if (res.code === 1001) {
                    dispatch({
                        type: "updateContext",
                        payload: {
                            user: null,
                            hasRole: false,
                        },
                    })
                }
                if (needReload) {
                    window.setTimeout(() => {
                        window.location.reload()
                    }, 500)
                }
            }}
            fetchRoleInfo={handleFetchRoleInfo}
            onNoRole={(res) => {
                dispatch({
                    type: "updateContext",
                    payload: { hasRole: false, user: null },
                })

                if (__LOCALE === "zh-cn")
                    !res.auto &&
                        EventBus.publish("showRoleSelect", {
                            message: "Hello from EventBus!",
                        })

                if (__LOCALE === "zh-tw")
                    Toast.message({ content: t("user.noRole") })
            }}
            // onError={(err) => {
            //     console.error(err)
            // }}
            // skipChannelSelect={__LOCALE === "zh-tw"}
            channels={
                __LOCALE !== "zh-cn" || returnButton
                    ? undefined
                    : [
                          {
                              channel: "bilibili",
                              option: {
                                  clientId: __BILIBILI_CLIENT_ID,
                              },
                          },
                      ]
            }
        >
            {children}
        </RoleProvider>
    )
}
export default Layout
